import type { SxProps, Theme } from "@mui/material/styles";

/** Shared horizontal inset for dialog title, content, and actions. */
export const SEEDIT_DIALOG_HORIZONTAL_PADDING = 3;

export const seeditDialogTitleSx: SxProps<Theme> = {
  px: SEEDIT_DIALOG_HORIZONTAL_PADDING
};

export const seeditDialogHeaderRowSx: SxProps<Theme> = {
  alignItems: "center",
  display: "flex",
  gap: 1,
  justifyContent: "space-between"
};

export const seeditDialogCloseIconButtonSx: SxProps<Theme> = {
  mr: -0.5
};

export const seeditDialogContentSx: SxProps<Theme> = {
  px: SEEDIT_DIALOG_HORIZONTAL_PADDING
};

export const seeditDialogActionsSx: SxProps<Theme> = {
  gap: 1,
  justifyContent: "flex-end",
  px: SEEDIT_DIALOG_HORIZONTAL_PADDING,
  pt: 0,
  pb: 2
};

export const mergeSeeditDialogSx = (
  base: SxProps<Theme>,
  override?: SxProps<Theme>
): SxProps<Theme> => (override ? ([base, override] as SxProps<Theme>) : base);
